import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../auth/auth.guard';
import { NotFoundComponent } from '../../pages/not-found/not-found.component';
import { environment } from 'src/environments/environment';
import { EnvironmentApplication } from 'src/environments/models/environment-application';

const routes: Routes = [
  {
    canActivate: [AuthGuard],
    path: '',
    pathMatch: 'full',
    redirectTo:
      environment.application === EnvironmentApplication.Studio ? '/explore' : '/results/modules',
  },

  // Legacy redirect paths, remove by December 2020
  {
    path: 'dashboard',
    pathMatch: 'full',
    redirectTo:
      environment.application === EnvironmentApplication.Studio
        ? '/results/bookmarks'
        : '/results/modules',
  },
  {
    path: 'explore/search',
    redirectTo: 'results/modules',
  },

  {
    path: 'account',
    loadChildren: () =>
      import('../../account/account.module').then((module) => module.AccountModule),
  },
  {
    path: 'login',
    loadChildren: () => import('../../login/login.module').then((module) => module.LoginModule),
  },
  {
    path: 'results',
    loadChildren: () => import('../../search/search.module').then((module) => module.SearchModule),
  },
  {
    path: 'explore',
    loadChildren: () =>
      import('../../explore/explore.module').then((module) => module.ExploreModule),
  },
  {
    path: 'view',
    loadChildren: () =>
      import('../../view-internal/view-internal.module').then(
        (module) => module.ViewInternalModule,
      ),
  },
  {
    path: 'edit',
    loadChildren: () => import('../../edit/edit.module').then((module) => module.EditModule),
  },
  {
    path: 'account',
    loadChildren: () =>
      import('../../account/account.module').then((module) => module.AccountModule),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
